module.exports = __webpack_public_path__ + "static/media/1.22b0128.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/test/1.wav
// module id = rd5l
// module chunks = 0